module.exports = __webpack_public_path__ + "img/journey.63819a84.svg";